export default __webpack_public_path__ + "static/media/campus.4ac9015d.jpg";